module.exports = __webpack_public_path__ + "img/3.ad1b9338.jpg";